import { useAuthContext } from '@context/auth/useAuthContext';
import { canSeeClientPricing } from '@feat-auth/clientPricing';

export interface InventoryMoneyVisibility {
  /** Purchase cost: internal economics, never shown to an office administrator. */
  showCost: boolean;
  /** Sale price and rental rate: client-facing money, see `canSeeClientPricing`. */
  showPrices: boolean;
}

/**
 * Which inventory money this user is shown. The backend withholds the rest, so a field that is not
 * shown must not be sent either: an absent key keeps the stored value, an empty one would erase it.
 */
export const useInventoryMoneyVisibility = (): InventoryMoneyVisibility => {
  const { user } = useAuthContext();
  return { showCost: !user.isOfficeAdmin || !!user.isAdmin, showPrices: canSeeClientPricing(user) };
};
